import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTicketingStore } from '@/stores';
import usePermission from '@/hooks/usePermission';
import { PermissionName } from '@/types';

const TicketPageHeader = () => {
  const { t } = useTranslation();
  const { hasPermission } = usePermission();
  const { openModal, setTicketFormData } = useTicketingStore();

  return (
    <button
      disabled={!hasPermission(PermissionName.CREATE_TICKET)}
      onClick={() => {
        openModal();
        setTicketFormData(undefined);
      }}
      className='flex items-center gap-2 h-9 px-4 rounded-xl bg-sd-primary text-sd-primary-foreground text-[13px] font-semibold hover:bg-sd-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer'
    >
      <Plus className='h-4 w-4' />
      {String(t('new_ticket'))}
    </button>
  );
};

export default TicketPageHeader;
